<ng-container *ngIf="lectureObservable | async; let lecture">
  <section class="p-5">
    <form (ngSubmit)="onSubmit(lecture)" class="w-100" [ngClass]=AppConfig.theme>
      <mat-card>
        <mat-card-content>
          <mat-form-field class="w-100">
            <input matInput placeholder="제목" [(ngModel)]="lecture.name" name="name" (ngModelChange)="onSubmit(lecture)">
          </mat-form-field>
          <simplemde-container>
            <textarea appSimpleMDE placeholder="설명" [(ngModel)]="lecture.syllabus" name="syllabus" (ngModelChange)="onSubmit(lecture)"></textarea>
          </simplemde-container>
        </mat-card-content>
      </mat-card>
    </form>
  </section>
</ng-container>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lecture-edit/lecture-edit.component.html